// extracted by mini-css-extract-plugin
var _1 = "ScormDataItem_content__97fbe";
var _2 = "ScormDataItem_pre__c94f7";
var _3 = "ScormDataItem_root__c67ba";
var _4 = "ScormDataItem_title__38c80";
export { _1 as "content", _2 as "pre", _3 as "root", _4 as "title" }
